export default __webpack_public_path__ + "static/media/avatar_tiger3.3408dcfa.mp3";